// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import styled from 'styled-components';
import { generateId } from '../_common/api/utility';
import Cart, { itemTypes } from '../_common/Cart';
import Button from '../_common/form/Button';
import { useGlobalState } from '../_common/globalState/GlobalStateProvider';
import LocationList from '../_common/LocationList';
import ImageCard from './ImageCard';
import { AddVehicle } from './pages/WashClubs';
import MenuRoutes from './MenuRoutes';
import '@fontsource/barlow-condensed'

const Wrapper = styled.div`
    padding: 1em 1em;
    color:  ${({ theme }) => theme.mobile.contrast};
    width: 80vw;
    height: 95%;
    display: flex;

    animation: slideInFromRight 0.3s;
`
const ColWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 0 0 1rem 1rem;
    color:  ${({ theme }) => theme.mobile.text};
    background-color: ${({ theme }) => theme.mobile.background};
    padding: 0 0.5em;
    overflow: hidden;
    height: 70%;
    justify-content: space-between;
`
const Image = styled(ImageCard)`
    height: 30%;
`
const Col = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0.2em;
`
const Shadow = styled.div`
    box-shadow: 1px 1px 3px 2px ${({ theme }) => theme.mobile.shadow};
    border-radius: 1rem;
    flex-grow: 1;
`
const InfoBox = styled.div`
    overflow: auto;
    padding: 1em 1em 1em 1em;
    font-size: 0.8em;
`
const Title = styled.div`
    // font-size: calc(1vw + 2.5vh);
    display: grid;
    font-size: clamp(1.6rem, 5vw + 0.5rem, 4rem);
    font-weight: 700;
    font-family : "Barlow Condensed", sans-serif;
    place-items: center;
`
const ProductCard = ({ title, price = 0, color, image, details, item, ...props }) => {
    const {
        state: {
            active_user,
            cart
        },
    } = useGlobalState();
    const routes = MenuRoutes();

    return (
        <Wrapper id={props.id}>
            <Shadow>
                <Image item={item} parentId={props.id}>
                    <Title>{title}</Title>
                </Image>
                <ColWrapper>
                    <InfoBox>
                        {
                            item.appProductType !== 'AppClub'
                                ? <Title style={{ fontSize: '2em' }}>${price.toFixed(2).replace('.00', '')}</Title>
                                : !item.payg ? <>
                                    {item.signupPrice !== price ? <Title style={{ fontSize: '1.5em' }}>First Month: ${item.signupPrice.toFixed(2).replace('.00', '')}</Title> : null}
                                    <Title style={{ fontSize: '1.5em' }}>Monthly: ${item.monthlyPrice.toFixed(2).replace('.00', '')}</Title>
                                </> : <><Title style={{ fontSize: '1.5em' }}>Pay-As-You-Go</Title>
                                {item.signupPrice != null && item.signupPrice > 0 &&
                                <Title style={{ fontSize: '1.5em' }}>Start Price: ${item.signupPrice.toFixed(2).replace('.00', '')}</Title>
                                }
                                </>
                        }
                        {item.value && <Title style={{ fontSize: '2em' }}>Value of: ${item.value.toFixed(2).replace('.00', '')}</Title>}
                        <LocationList itemLocations={item.locations} />
                        {details?.map(e => <p key={generateId()}>{e}</p>)}
                    </InfoBox>
                    <Col>
                        {
                            active_user.isLoggedIn ?
                                item.productType === itemTypes.washClub && !active_user.vehicle ?
                                    <AddVehicle /> :
                                                <> 
                                                    {Cart.GiftButton(item)}
                                                    {Cart.AddButton(item)}
                                                    {
                                                        cart.length > 0 ?
                                                        <Button to={routes.checkout.route}>Complete Purchase</Button> :
                                                        item.productType !== itemTypes.washClub && <Button onClick={() => Cart.BuyNow(item)}>Buy Now!</Button>
                                                    }
                                                </>
                            : null
                        }
                    </Col>
                </ColWrapper>
            </Shadow>
        </Wrapper>
    );
}

export default ProductCard;